import ActiveFormComponent from './ActiveForm'
export default (Vue) => {
  Vue.component(ActiveFormComponent.name, ActiveFormComponent)
}



// WEBPACK FOOTER //
// ./src/components/ActiveForm/index.js